import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchVendorTypes, requestLineItems, updateLineItem, createLineItem, setLineItemFilters } from 'actionCreators/line_items';
import PageActionBar from 'components/PageActionBar';
import ReactSelect from 'components/StyledSelect/react_select';
import FiltersDrawer from 'components/FiltersDrawer';
import LineItemRow from 'lineItemRow';
import LineItemTable from 'components/LineItemTable';
import phaseMerchandiseItem from 'types/phaseMerchandiseItem';
import contentAreaStyles from 'styles/contentArea';
import { NON_LHI_SOURCES, displayVendorLabel } from 'config/constants';

class LineItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersDrawerActive: false,
      selectedVendor: '',
    };
    this.onSearch = this.onSearch.bind(this);
    this.toggleFiltersDrawer = this.toggleFiltersDrawer.bind(this);
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
  }

  componentWillMount = () => this.refreshLineItemList();

  onSearch = (e) => {
    e.preventDefault();
    const value = e.target.value || e.target.searchText || e.target.querySelector('input').value;
    const filters = { ...this.props.filters, query: value, vendor: this.state.selectedVendor };
    this.props.setLineItemFilters(filters);
  };

  refreshLineItemList = () => {
    this.props.fetchVendorTypes();
    this.props.requestLineItems();
  }

  handleVendorChange = (selectedOption) => {
    const vendor = selectedOption ? selectedOption.value : '';
    const filters = { ...this.props.filters, vendor, query: this.props.filters.query };
    this.setState({ selectedVendor: vendor });
    this.props.setLineItemFilters(filters);
  };

  handleSave = lineItem => (lineItem.id < 0 ?
    this.props.createLineItem(lineItem) : this.props.updateLineItem(lineItem));

  toggleFiltersDrawer = () => this.setState(prevState => ({
    filtersDrawerActive: !prevState.filtersDrawerActive,
  }));

  resetFilters = () => {
    this.setState({ selectedVendor: '' });
    this.props.setLineItemFilters({ vendor: '', query: '' });
  }

  itemsByVendor = (items, mvw) => items.filter((item) => {
    const vendor = typeof item === 'object' ? (item.vendor || null) : (item || null);
    if (!vendor) return true;
    if (NON_LHI_SOURCES.includes(vendor)) return mvw[vendor.toLowerCase()] === true;
    return (mvw.lhi || false) === true;
  });

  render = () => {
    const { lineItems, vendorTypes, filters, user: { manage_vendor_workrooms: mvw } } = this.props;
    const { selectedVendor, filtersDrawerActive } = this.state;
    const filteredVendorTypes = this.itemsByVendor(vendorTypes, mvw);
    const filteredLineItems = this.itemsByVendor(lineItems.filter((item) => {
      const matchesVendor = !filters.vendor || item.vendor === filters.vendor;
      const matchesSearch = !filters.query || (
        item.item_number && item.item_number.includes(filters.query)
      );
      return matchesVendor && matchesSearch;
    }), mvw);
    return (<div>
      <PageActionBar
        showFiltersBtn
        showAdd={false}
        title="Line Items"
        searchText="Search for a Line Item number..."
        onSearch={this.onSearch}
        toggleFilters={this.toggleFiltersDrawer}
      />
      <FiltersDrawer
        title="Line Items"
        active={filtersDrawerActive}
        toggle={this.toggleFiltersDrawer}
        reset={this.resetFilters}
      >
        <ReactSelect
          key="vendors"
          className={contentAreaStyles.dropdown}
          label="Vendors"
          name="vendors"
          placeholder="All Vendors"
          options={filteredVendorTypes.map(vendor =>
            ({ value: vendor, label: displayVendorLabel(vendor) }))}
          value={selectedVendor ?
            { value: selectedVendor, label: displayVendorLabel(selectedVendor) } : null}
          onChange={this.handleVendorChange}
        />
      </FiltersDrawer>
      <div className={contentAreaStyles.contentAreaContainer}>
        <LineItemTable
          adminTable
          editableOnly
          title=""
          refreshList={this.refreshLineItemList}
        >{filteredLineItems.map(item => <LineItemRow
          key={item.id}
          onSave={this.handleSave}
          lineItem={item}
          vendorTypes={filteredVendorTypes}
        />)}</LineItemTable>
      </div>
    </div>);
  }
}

LineItems.defaultProps = { lineItems: [], vendorTypes: [] };

LineItems.propTypes = {
  phaseId: PropTypes.string,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape(phaseMerchandiseItem),
  ),
  requestLineItems: PropTypes.func,
  updateLineItem: PropTypes.func,
  createLineItem: PropTypes.func,
  setLineItemFilters: PropTypes.func,
  filters: PropTypes.shape({
    vendor: PropTypes.string,
    query: PropTypes.string,
  }),
  vendorTypes: PropTypes.arrayOf(PropTypes.string),
  fetchVendorTypes: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = state => ({
  lineItems: state.lineItems.items,
  vendorTypes: state.lineItems.vendorTypes,
  filters: state.lineItems.filters || { vendor: '', query: '' },
  user: state.user,
});

const mapDispatchToProps = {
  requestLineItems,
  updateLineItem,
  createLineItem,
  setLineItemFilters,
  fetchVendorTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(LineItems);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/lineItems/index.jsx